module.exports = __webpack_public_path__ + "img/platform0.2941f40e.png";